<div class="pnl-showcase">
    <header>
        <h1>Vitrine</h1>
        <a [routerLink]="['/app/vitrine-cadastro']">Criar vitrine</a>
    </header>
    <section class="pnl-zero" [class.dnone]="showcases.length > 0">
        <i class="ic ic-showcase"></i>
        <h4>Crie rapidamente vitrines temáticas<br>para destacar produtos ou marcas</h4>
        <a [routerLink]="['/app/vitrine-cadastro']" class="btn btn-primary">Comece a criar agora</a>
    </section>

    <section class="pnl-list" [class.dnone]="showcases.length == 0">

        <div cdkDropList class="showcase-list" (cdkDropListDropped)="drop($event)">
            <div class="showcase-box" *ngFor="let showcase of showcases; let i=index" cdkDrag [class.showcase-box-disabled]="false">
                <div class="cdkDragHandle" cdkDragHandle><i class="ic ic-dots"></i></div>
                <div class="showcase-custom-placeholder" *cdkDragPlaceholder></div>
                <div class="showcase-data">
                  <div class="showcase-infos">
                    <strong [class.tgray]="showcase.status=='I'">{{showcase.nome}}</strong>
                    <span [class.hidden]="showcase.status=='I'">{{showcase.num_produtos}} produtos na vitrine</span>
                  </div>
                  <div class="showcase-actions">
                    <a [routerLink]="['/app/vitrine-cadastro/'+showcase.idvitrine]">
                      <i class="ic ic-pen"></i>
                      Editar
                    </a>
                    <a (click)="onRemove(showcase, i)">
                      <i class="ic ic-delete"></i>
                      Excluir
                    </a>

                    <div class="ipt-switch">
                        <input [id]="'ckStatus'+showcase.idvitrine" [(ngModel)]="showcase.ckStatus" (change)="updateStatus(showcase)" type="checkbox" value="S" name="status">
                        <label [for]="'ckStatus'+showcase.idvitrine"></label>
                    </div>
                  </div>
                </div>
            </div>
        </div>

    </section>

    <div class="loading" *ngIf="loadingShowcase">
        <div class="loadingio-spinner-eclipse-cz3y1wre1nd">
            <div class="ldio-ns36390yc">
                <div></div>
            </div>
        </div>
    </div>
</div>
